export const hasParentWithClassName = (node, className) => {
  if (!node) {
    return false;
  }
  if (node.className === className) {
    return true;
  }

  return hasParentWithClassName(node.parentNode, className);

};

export const autoGrowTextarea = (element, cb) => {
  const computedStyles = getComputedStyle(element);
  let topAndBottomBordersWidthSum = 0;
  topAndBottomBordersWidthSum += parseInt(
    computedStyles.getPropertyValue('border-top-width').replace('px', '')
  );
  topAndBottomBordersWidthSum += parseInt(
    computedStyles.getPropertyValue('border-bottom-width').replace('px', '')
  );
  const initialScrollHeight = element.scrollHeight + topAndBottomBordersWidthSum;
  cb(initialScrollHeight);
  element.addEventListener('input', (event) => {
    event.target.style.height = `${initialScrollHeight}px`;
    const newHeight = event.target.scrollHeight + topAndBottomBordersWidthSum;
    event.target.style.height = `${newHeight}px`;
    cb(newHeight);
  });
};
